import { ExternalImagesOptions } from 'owa-outlook-service-options';
import { mutatorAction } from 'satcheljs';

/**
 * Mutator triggered to save the updated value in store.
 */
export default mutatorAction(
    'updateExternalImagesOption',
    (userOptions: ExternalImagesOptions, selectedOption: number) => {
        userOptions.externalImagesSelectedOption = selectedOption;
    }
);
